import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenvpnComponent } from './simple-icons-openvpn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenvpnComponent ],
    exports:      [ SimpleIconsOpenvpnComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenvpnModule {}
